var $ = require('../internals/export');
var numberIsFinite = require('../internals/number-is-finite');

// `Number.isFinite` method
// https://tc39.github.io/ecma262/#sec-number.isfinite
$({ target: 'Number', stat: true }, { isFinite: numberIsFinite });



//////////////////
// WEBPACK FOOTER
// c:/Users/Antanas/Dropbox/am/Projects/typescript/amcharts4dev/node_modules/core-js/modules/es.number.is-finite.js
// module id = yv8f
// module chunks = a74a